import { Controller } from 'react-hook-form';
import { SidePanelRow, Select } from '@ui/src';
import { RatesFormTypes } from './types';

import cn from './styles.module.css';

const RatesForm = ({
  control,
  errors,
  onSubmit,
  children,
  rateSources,
}: RatesFormTypes): React.JSX.Element => (
  <form onSubmit={onSubmit} className={cn.details}>
    <SidePanelRow caption="Base Rate Source">
      <Controller
        control={control}
        name="baseRateSource"
        render={({ field: { onChange, value, name } }) => (
          <Select
            name={name}
            onChange={onChange}
            value={value}
            list={rateSources?.map((item) => ({
              name: item.name,
              value: item.id,
            }))}
            placeholder="Select base rate source"
            error={errors?.baseRateSource?.message}
          />
        )}
      />
    </SidePanelRow>

    <SidePanelRow caption="Exchange Rate Source">
      <Controller
        control={control}
        name="exchangeRateSource"
        render={({ field: { onChange, value, name } }) => (
          <Select
            name={name}
            onChange={onChange}
            value={value}
            list={rateSources?.map((item) => ({
              name: item.name,
              value: item.id,
            }))}
            placeholder="Select exchange rate source"
            error={errors?.exchangeRateSource?.message}
          />
        )}
      />
    </SidePanelRow>

    {children}
  </form>
);

export default RatesForm;
